<div class="executed-summary">
  <div class="executed-summary__content">
    <p class="ft-16 mb-0">Initi&euml;le opdracht:</p>

    <div class="executed-summary__products-list">
      <div
        class="d-flex flex-wrap"
        *ngFor="
          let product of products;
          let lastProduct = last;
          let firstProduct = first
        "
      >
        <p class="title ft-16">
          {{ product | productTypeConfig : 'boardPart' }} -
        </p>

        <p class="title ft-16 ml-1" [innerHTML]="getProductSize(product)"></p>

        <p class="title ft-16 ml-1">- {{ product | productTitleSummary }}</p>

        <p *ngIf="firstProduct && !!extrasString" class="title ft-16 ml-2">
          /
          <span class="important">+ {{ extrasString }}</span>
        </p>
      </div>
    </div>

    <p class="accent mt-2 mb-3">
      {{ address?.line1 | printAddress : address?.postalCode : address?.city }}
      <span class="normal" *ngIf="placementFloor != null">
        - Verdiep: {{ placementFloor }}
      </span>
    </p>

    <ng-container *ngIf="products.length > 0">
      <ng-container
        *ngIf="
          products[0].boardPart != null &&
            products[0].boardPart.sign != null &&
            products[0].boardPart.sign.poleColor != null;
          else poleColorTemplate
        "
      >
        <p class="mt-2 mb-3 strong">
          {{ products[0].boardPart.sign.poleColor.label }} hout
        </p>
      </ng-container>

      <ng-template #poleColorTemplate>
        <p class="mt-2 mb-3 strong" *ngIf="products[0].poleColor != null">
          {{ products[0].poleColor.label }} hout
        </p>
      </ng-template>
    </ng-container>

    <p
      *ngIf="originalPlacementDate != null || originalPlacers != null"
      class="ft-16 mt-3"
    >
      Plaatsing uitgevoerd op:
      <b *ngIf="originalPlacementDate != null">
        {{ originalPlacementDate | date : 'dd/MM/yyyy' }}
      </b>

      <span *ngIf="originalPlacers != null"> ({{ originalPlacers }})</span>
    </p>
  </div>

  <div
    *ngIf="executionAssets != null && executionAssets.length > 0"
    class="executed-summary__images"
  >
    <img
      *ngIf="isImage(executionAssets[0].asset)"
      class="max-summary-width max-summary-height clickable"
      src="/api/assets/{{ executionAssets[0].asset.uuid }}"
      (click)="openLightbox()"
    />
  </div>
</div>
